<template>
    <div class="col-12">
            <span class="top-actions"> 
                   <router-link class="nav-link" :style= "active=='appointment'? { backgroundColor: 'beige', borderTopLeftRadius:'5px', borderTop:'0.5px solid green', borderLeft:'0.5px solid green', borderRight:'0.5px solid green'} : { backgroundColor: 'white'}" to="/reception_appointments" v-bind="$attrs">Appointments</router-link>
                   <router-link class="nav-link"  :style= "active=='visits'? { backgroundColor: 'beige', borderTopLeftRadius:'5px', borderTop:'0.5px solid green', borderLeft:'0.5px solid green', borderRight:'0.5px solid green'} : { backgroundColor: 'white'}"  to="/reception" v-bind="$attrs">Visits</router-link>
            </span>
        </div>
        <hr/>
</template>

<script>
export default{
    name:"receptiontop",
    data(){
        return{
            active:"visits",
        };
        
    },
    methods:{

    },
    mounted() {
        console.log();
        const mainString = this.$route.path;
        const subString = "appointment";
        if (mainString.includes(subString)) {
            this.active = "appointment";
        }else{
            this.active = "visits";
        }

        console.log(); // Output: true
    },
}
</script>

